export default [
    {
        name: 'queryQuotesConfigLists',
        url: '/lists'
    },
    {
        name: 'deleteQuotesConfig',
        url: '/delete'
    },
    {
        name: 'fetchQuotesConfig',
        url: '/detail'
    },
    {
        name: 'updateQuotesConfig',
        url: '/update'
    },
    {
        name: 'addQuotesConfig',
        url: '/add'
    },
    {
        name: 'quoteResults',
        url: '/result_lists'
    },
    {
        name: 'exportResults',
        url: '/result_export'
    },
    {
        name: 'deleteQuoteResult',
        url: '/delete_result'
    }
];
